import { ScreenBase } from "@frui.ts/screens";
import { interfaces } from "inversify";
import { computed, observable, action } from "mobx";
import LocalizationService from "services/localizationService";
import { getValidationMessage } from "utils/validationPatch";
import EnumService from "../../services/enumService";
import ChargeTypesService from "services/chargeTypesService";
import FuelTypeViewModel from "viewModels/eshop/order/components/fuelViewModel";
import FuelTypeResponse from "entities/fuelTypeResponse";
import ChargeOrderFuelItem from "models/chargeOrderFuelItem";
import ChargeOrderItem from "models/chargeOrderItem";

export default class FuelTypeSelectViewModel extends ScreenBase {
  @observable batchIndex: number | undefined;
  protected unsubscriptions: Array<() => void> = [];

  constructor(
    public chargeOrderFuelItem: ChargeOrderFuelItem | ChargeOrderItem,
    public localizationService: LocalizationService,
    public enumService: EnumService,
    private chargeTypesService: ChargeTypesService,
    private fuelTypeViewModelFactory: ReturnType<typeof FuelTypeViewModel.Factory>
  ) {
    super();
  }

  @action.bound
  clickOutside() {
    this.fuelTypeViewModels.forEach(x => {
      x.displayTooltip = false;
    });
  }

  @computed
  get fuelTypes() {
    return this.enumService.values("fuel_types") as FuelTypeResponse[];
  }

  @computed
  get fuelTypeViewModels() {
    const validFuelTypes = this.fuelTypes.filter(
      fuelType =>
        this.chargeTypesService.chargePriceList?.includedFuelTypeIds.includes(fuelType.id.toString()) && !fuelType.isDeleted
    );
    return validFuelTypes.map(item => this.fuelTypeViewModelFactory(item, this.chargeOrderFuelItem));
  }

  @computed
  get isInitialized() {
    return this.chargeTypesService.isInitialized;
  }

  @computed
  get fuelTypeError() {
    return getValidationMessage(this.chargeOrderFuelItem, "fuelTypeId");
  }

  static Factory({ container }: interfaces.Context) {
    return (chargeOrderFuelItem: ChargeOrderFuelItem | ChargeOrderItem) => {
      return new FuelTypeSelectViewModel(
        chargeOrderFuelItem,
        container.get(LocalizationService),
        container.get(EnumService),
        container.get(ChargeTypesService),
        container.get(FuelTypeViewModel.Factory)
      );
    };
  }
}
